module.exports = __webpack_public_path__ + "static/media/anamnese-icon.ccbef7e2.svg";